<template>
  <div>
    <div v-if="isLoading">Laden...</div>
    <div v-else-if="!cases || cases.length === 0">Geen cases voor dit adres</div>
    <div v-else class="tw-flex tw-flex-col tw-gap-2">
      <router-link
        v-for="c in cases"
        :key="c.id"
        :to="{ name: 'case-detail', params: { id: c.id } }"
        target="_blank"
        class="tw-block tw-border tw-rounded tw-p-2 hover:tw-bg-gray-50 tw-text-black"
      >
        <div class="tw-flex tw-items-center tw-gap-2">
          <b>#{{ c.id }}</b>
          <span>{{ c.category }}</span>
          <CaseStatus :status="c.status" />
          <span class="tw-ml-auto tw-text-gray-500">{{ c.opened_at ? formatDate(c.opened_at) : '' }}</span>
        </div>
        <div v-if="c.description" class="tw-text-gray-600 tw-truncate">{{ c.description }}</div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatDate } from '@/util/DateTime'
import CaseStatus from '@/components/TicketCases/CaseStatus.vue'
import { useAddressCases } from './composables/useAddressCases'

const props = defineProps({
  locationId: { type: String, default: null },
})

const { data: cases, isInitialLoading: isLoading } = useAddressCases(computed(() => props.locationId))
</script>
